/*eslint-disable*/
import React, {useState, useEffect, useContext} from "react";
import {Link} from "react-router-dom";
import NotificationDropdown from "../Dropdowns/TableDropdown";
import UserDropdown from "../Dropdowns/UserDropdown";
import {getMenu} from "./../../api/auth.service"
import {SearchMenu} from "../Navbars/components/SearchMenu";
import './style.scss'
import {Li} from "./components/Li";
import {AppContext} from "../../context/appContext";
import {types} from "../../shared/types/types";

export default function Sidebar() {
    const [collapseShow, setCollapseShow] = useState("hidden");
    const [menus, setMenus] = useState([]);
    const dropdown = document.getElementsByClassName("dropdown-btn-custom");
    const {user} = useContext(AppContext);

    const {dispatch} = useContext(AppContext);

    const closeMenu = () => {
        const action = {
            type: types.showMenu,
            payload: false
        }
        dispatch(action)
    }

    const toggleMenu = () => {
        for (const element of dropdown) {
            element.addEventListener("click", function () {
                let dropdownContent = this.nextElementSibling;
                if (dropdownContent.style.display === "block") {
                    dropdownContent.style.display = "none";
                } else {
                    dropdownContent.style.display = "block";
                }
            });
        }
    }

    useEffect(() => {
        if (user.showMenu) {
            setTimeout(() => {
                toggleMenu();
            }, 500);
         }

        return () => {
            if (user.showMenu) {
                //clearTimeout(timeoute);
                for (const element of dropdown) {
                    element.removeEventListener('click');
                }
            }
        };
    }, [dropdown, user.showMenu]);

    useEffect(() => {
        async function fetchData() {
            const response = await getMenu();
            const data = await response.data;
            const navMenu = data.data;
            localStorage.setItem('menu', JSON.stringify(navMenu));
            const groups = new Set(navMenu.map(item => item.descripcion));
            let arrayMenu = [];
            groups.forEach(g => {
                let option = {
                    name: g,
                    values: navMenu.filter(i => i.descripcion === g)
                }
                arrayMenu = [...arrayMenu, option]
            })
            return arrayMenu;
        }

        fetchData().then(r => {
            setMenus([...r])
        });
        return () => {
            setMenus([]);
        };
    }, []);

    return (
        <>
            {user.showMenu && <nav
                className=" md:block md:fixed md:top-0 md:bottom-0  md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-4 md:w-64 md:overflow-y-auto z-20  py-4 px-6">
                <div
                    className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
                    {/* Toggler */}
                    <button
                        className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                        type="button"
                        onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
                    >
                        <i className="fas fa-bars "/>
                    </button>

                    {/* Brand */}

                    <button
                        className="mt-3 cursor-pointer text-black  opacity-50  py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                        type="button"
                        onClick={() => closeMenu()}
                    >
                        <i className="fas fa-bars "/>
                    </button>
                    <Link
                        className="md:block  text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                        to="/home"
                    >
                        <i className="fas fa-home opacity-0 md:opacity-100"/>
                        <span className="ml-3 opacity-0 md:opacity-100">Toa administrador</span>
                    </Link>

                    {/* User */}
                    <ul className="md:hidden items-center flex flex-wrap list-none">
                        <li className="inline-block relative">
                            <NotificationDropdown/>
                        </li>
                        <li className="hidden md:inline-block relative">
                            <UserDropdown/>
                        </li>
                    </ul>
                    {/* Collapse */}
                    <div
                        className={
                            "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
                            collapseShow
                        }
                    >
                        {/* Collapse header */}
                        <div
                            className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
                            <div className="flex flex-wrap">
                                <div className="w-6/12">
                                    <Link
                                        className="md:block text-left md:pb-2 text-lightBlue-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                                        to="/home"

                                    >
                                        Toa administrador
                                    </Link>
                                </div>
                                <div className="w-6/12 flex justify-end">
                                    <button
                                        type="button"
                                        className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                                        onClick={() => setCollapseShow("hidden")}
                                    >
                                        <i className="fas fa-times"/>
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* Form */}
                        <form className="mt-6 mb-4 md:hidden">
                            <div className="mb-3 pt-0">
                                <SearchMenu/>
                            </div>
                        </form>

                        {/* Divider */}
                        <hr className="my-4 md:min-w-full"/>
                        {/* Heading */}
                        {menus.map((menu, key) => {
                                return (
                                    <div key={key}>
                                        <button
                                            className="md:min-w-full  text-lightBlue-800 hover:text-lightBlue-900 text-base uppercase font-bold block pt-1 pb-4 no-underline focus:outline-none text-left dropdown-btn-custom">
                                            <i className="fa fa-caret-down mr-2" aria-hidden="true"></i>
                                            {menu.name}
                                            {/* Divider */}
                                            <hr className="my-4 md:min-w-full"/>

                                        </button>

                                        <ul className="md:flex-col md:min-w-full flex flex-col list-none dropdown-container">
                                            {menu.values.map((value, i) => (
                                                <Li key={i} pagina={value.pagina} submenu={value.submenu}
                                                    icono={value.icono}/>
                                            ))}
                                        </ul>

                                    </div>
                                )
                            }
                        )}
                    </div>
                </div>
            </nav>}
        </>
    );
}
